export default {"src":"/_next/static/media/x_icon.1115dd19.svg","height":40,"width":40};